module.exports = __webpack_public_path__ + "img/menu-02.48c26f0d.svg";